export enum Bundesland {
  BADEN_WUERTTEMBERG = 'Baden-Württemberg', //DONE
  BAVARIA = 'Bayern', //DONE
  BERLIN = 'Berlin', //DONE
  BRANDENBURG = 'Brandenburg', //DONE
  BREMEN = 'Bremen',
  HAMBURG = 'Hamburg', //DONE
  HESSE = 'Hessen', //DONE
  MECKLENBURG_WESTERN_POMERANIA = 'Mecklenburg-Vorpommern', //DONE
  LOWER_SAXONY = 'Niedersachsen', //DONE
  NORTH_RHINE_WESTPHALIA = 'Nordrhein-Westfalen', //DONE
  RHINELAND_PALATINATE = 'Rheinland-Pfalz',
  SAARLAND = 'Saarland', //DONE
  SAXONY = 'Sachsen', //DONE
  SAXONY_ANHALT = 'Sachsen-Anhalt', //DONE
  SCHLESWIG_HOLSTEIN = 'Schleswig-Holstein', //DONE
  THURINGIA = 'Thüringen', //DONE
  EMPTY = ''
}